import { Segment } from "./Segment";
import { Size } from "./Size";
import { Selectable } from "../Selectable";
import { IColorChangeable, ICloneable } from "../../Interfaces";
import { ArrowHolder } from "../Dimensions/ArrowHolder";
import { Label } from "../Label";
import { SizeDim } from "./SizeDim";
import { LabelDim } from "./LabelDim";
import { CmToFtAndInch } from "../../lengthConvertor";

declare const THREE: any;

export class Dimensions extends Selectable
  implements IColorChangeable, ICloneable {
  private startPoint;
  private endPoint;
  private color;
  public Length: number;
  static readonly Name = 'Dimensions';
  public text;
  public modifiedAtStep3: boolean = false;

  constructor() {
    super();
    this.startPoint = new THREE.Vector3();
    this.endPoint = new THREE.Vector3();
    this.color = new THREE.Color(0x000000);
    this.add(new Segment());
    this.add(new SizeDim());
    this.add(new Size());
    this.add(new ArrowHolder("firstArrow"));
    this.add(new ArrowHolder("secondArrow"));
    this.name = Dimensions.Name;
  }

  update(startPoint, endPoint) {
    this.startPoint.copy(startPoint);
    this.endPoint.copy(endPoint);
    const size = startPoint.distanceTo(endPoint);
    this.text = CmToFtAndInch(size);
    this.getObjectByName<Segment>(Segment.Name).update(startPoint, endPoint);

    this.getObjectByName<SizeDim>(LabelDim.Name).update(startPoint, endPoint);
    this.getObjectByName<Size>(Label.Name).update(startPoint, endPoint);

    const offset = startPoint.clone().negate();
    // startPoint.add(offset);
    // endPoint.add(offset);

    this.getObjectByName<ArrowHolder>("firstArrow").update(
      startPoint.clone().add(offset),
      endPoint.clone().add(offset)
    );
    this.getObjectByName<ArrowHolder>("secondArrow").update(
      endPoint.clone().add(offset),
      startPoint.clone().add(offset)
    );

    // this.getObjectByName<ArrowHolder>("firstArrow").update(startPoint.clone().setLength(startPoint.length() / 2), endPoint.clone().setLength(endPoint.length() / 2));
    // this.getObjectByName<ArrowHolder>("secondArrow").update(endPoint.clone().setLength(endPoint.length() / 2), startPoint.clone().setLength(startPoint.length() / 2));
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName(Segment.Name)];
  }

  setColor(color): void {
    this.color.copy(color);
    this.getObjectByName(Segment.Name).setColor(color);
  }

  duplicate(): Dimensions {
    const result = new Dimensions();
    result.modifiedAtStep3 = true;
    result.update(this.startPoint, this.endPoint);
    result.setColor(this.color);
    return result;
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    return {
      type: "Dimensions",
      position: pos,
      startPoint: { x: this.startPoint.x, y: this.startPoint.y, z: this.startPoint.z },
      endPoint: { x: this.endPoint.x, y: this.endPoint.y, z: this.endPoint.z },
      text: this.text,
      color: this.color.getHex()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Dimensions/index.ts